<template>
    <div class="website-container">
        <div class="title d-md-none">Website</div>
        <website-tile-container></website-tile-container>
        <transition name="fade">
            <h1 class="max-container loading" v-if="refreshingPacing">Loading table<span class="indicator">.</span><span class="indicator">.</span><span class="indicator">.</span></h1>
            <website-table v-if="!refreshingPacing && tableData"></website-table>
        </transition>
    </div>
</template>

<script>
    import store from '@/store';

    import WebsiteTileContainer from '@/components/tiles/WebsiteTileContainer';
    import BigChartContainer from '@/components/BigChartContainer';
    import WebsiteTable from '@/components/WebsiteTable';

    export default {
        components: {
            WebsiteTileContainer,
            BigChartContainer,
            WebsiteTable,
        },
        computed: {
            tableData() {
                return store.state.websiteData.table;
            },
            refreshingCharts() {
                return store.state.refreshStatusCharts;
            },
            refreshingPacing() {
                return store.state.refreshStatusPacing;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../assets/scss/partials/variables';

    .title {
        margin-bottom: 25px;
        color: $kpmg-blue;
        font-size: 40px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/WebsiteContainer.vue